export default "__VITE_ASSET__BID4pwZP__"